/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Header_Ai_Agents_DetailInputs */

const en_common_header_ai_agents_detail = /** @type {(inputs: Common_Header_Ai_Agents_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Structured product data`)
};

const zh_common_header_ai_agents_detail = /** @type {(inputs: Common_Header_Ai_Agents_DetailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`结构化产品数据`)
};

/**
* | output |
* | --- |
* | "Structured product data" |
*
* @param {Common_Header_Ai_Agents_DetailInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const common_header_ai_agents_detail = /** @type {((inputs?: Common_Header_Ai_Agents_DetailInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Header_Ai_Agents_DetailInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_common_header_ai_agents_detail(inputs)
	return zh_common_header_ai_agents_detail(inputs)
});
export { common_header_ai_agents_detail as "common.header.ai.agents.detail" }